module.exports = __webpack_public_path__ + "static/media/YF72_2.10c7c768.jpg";